import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import FieldText from 'containers/components/Fields/Text';
import { getLiteral } from 'utils/getLiteral';

const propTypes = {
    field: PropTypes.object.isRequired,
    description: PropTypes.string,
    value: PropTypes.string,
    mandatory: PropTypes.bool,
    readOnly: PropTypes.bool,
    hidden: PropTypes.bool,
    multiLine: PropTypes.bool,
    tooltip: PropTypes.string,
    inputType: PropTypes.string,
    error: PropTypes.string,
    onChange: PropTypes.func,
};

const CompanyTextField = memo(
    ({
        field,
        description,
        value,
        mandatory,
        readOnly,
        hidden,
        multiLine,
        tooltip,
        inputType,
        error,
        onChange,
    }) => {
        const onFieldChange = useCallback(
            (newValue) => {
                onChange && onChange(field.id.toLowerCase(), newValue);
            },
            [field, onChange],
        );

        const type = inputType || (multiLine ? 'textarea' : 'text');
        const displayValue = value != null ? String(value) : '';

        if (hidden) return null;

        return (
            <FieldText
                label={description}
                labelMode="horizontal"
                description={tooltip ? getLiteral(tooltip) : undefined}
                value={displayValue}
                mandatory={mandatory}
                readOnly={readOnly}
                error={error}
                onChange={onFieldChange}
                type={type}
            />
        );
    },
);

CompanyTextField.propTypes = propTypes;
export default CompanyTextField;
